export default __webpack_public_path__ + "static/media/alternative-logo-hydraulica.af9d3fe6.png";